(function() {
  const TGLProduct = window.TGLProduct = window.TGLProduct || {};

  function updateModelInfo(ctx, variantId) {
    const modelSection = document.getElementById('modelInfoSection');
    if (!modelSection || !ctx.data.variantModels) return;

    const model = ctx.data.variantModels[variantId];
    if (!model) {
      modelSection.style.display = 'none';
      return;
    }

    const modelImage = modelSection.querySelector('.model-image');
    const primaryImage = model.thumbnail || model.image;
    let titleText = '';
    let measurementParts = [];

    if (modelImage) {
      if (primaryImage) {
        const altText = model.name ? `${model.name} wearing product` : '';
        modelImage.innerHTML = `<img src="${primaryImage}" alt="${altText}" class="model-photo" width="160" height="200">`;
        modelImage.style.display = '';
      } else {
        modelImage.innerHTML = '';
        modelImage.style.display = 'none';
      }
    }

    const modelTitle = modelSection.querySelector('.model-title');
    if (modelTitle) {
      const sizeValue = model.option1 && model.option1.length === 1 ? model.option1 : model.option2 && model.option2.length === 1 ? model.option2 : '';

      if (model.name && sizeValue) {
        titleText = `${model.name}'s wearing a size ${sizeValue}`;
      } else if (model.name) {
        titleText = model.name;
      } else if (sizeValue) {
        titleText = `Wearing a size ${sizeValue}`;
      }

      modelTitle.textContent = titleText;
      modelTitle.style.display = titleText ? '' : 'none';
    }

    const measurements = modelSection.querySelector('.model-measurements');
    if (measurements) {
      if (model.name) {
        measurementParts.push(`<p>${model.name}'s Measurements:</p>`);
      }
      if (model.height) {
        measurementParts.push(`<p>Height: ${model.height}</p>`);
      }
      if (model.chest) {
        measurementParts.push(`<p>Chest: ${model.chest}</p>`);
      }
      if (model.waist) {
        measurementParts.push(`<p>Waist: ${model.waist}</p>`);
      }
      if (model.hips) {
        measurementParts.push(`<p>Hips: ${model.hips}</p>`);
      }

      measurements.innerHTML = measurementParts.join('');
      measurements.style.display = measurementParts.length ? '' : 'none';
    }

    const hasContent = Boolean(primaryImage || titleText || measurementParts.length);
    modelSection.style.display = hasContent ? '' : 'none';
  }

  TGLProduct.updateModelInfo = updateModelInfo;
})();
